import { updatesApi } from '../api/updates';
import { usePoll } from '../hooks/usePoll';
import { ErrorAlert } from '../components/ui';

/** それより前の更新は GitHub の Releases で見る（画面の一覧は版を重ねるたびに伸び続けるため、利用者の決定 2026-10-12） */
export const RELEASES_URL = 'https://github.com/R0319/mc-panel/releases';

export function ReleaseHistory() {
  const releases = usePoll(updatesApi.releases, 30_000);
  // 直近の更新（今の版）の内容だけを出す。今の版のノートが無ければ、いちばん新しいノートを出す
  const latest = releases.data?.find((release) => release.current) ?? releases.data?.[0];
  return (
    <section aria-label="更新履歴" className={latest?.security ? 'stack release-security' : 'stack'}>
      <h3>直近の更新</h3>
      <ErrorAlert error={releases.error} />
      {!releases.data && !releases.error && <p>確認中…</p>}
      {releases.data?.length === 0 && <p>更新履歴はまだありません。</p>}
      {latest && (
        <>
          <p>
            <strong>{latest.version}</strong> {latest.current && <span className="tag">今の版</span>}{' '}
            {latest.security && <span className="tag">セキュリティ修正</span>}
          </p>
          <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontFamily: 'inherit' }}>{latest.notes}</pre>
        </>
      )}
      <p className="small muted">
        それより前の更新は{' '}
        <a href={RELEASES_URL} target="_blank" rel="noreferrer">
          GitHub の Releases
        </a>{' '}
        で確認できます。
      </p>
    </section>
  );
}
